import React, { forwardRef } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import VMSecureStateMappingForm from './VMSecureStateMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';

function VMSecureStateCredentialForm(props, ref) {
    const fields = [
    {
        name: "apiEndpoint",
        label: "API Endpoint",
        rules:[urlRegexValidator],
        required: true
    }, {
        name: "token",
        label: "Token",
        required: true,
        type: FieldTypes.PASSWORD,
    }];

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={VMSecureStateMappingForm}
            initialValue={{ apiEndpoint: "https://api.securestate.vmware.com" }}
        />
    )
}

export default forwardRef(VMSecureStateCredentialForm);